export default "__VITE_ASSET__68cbaf7f__"